import React, {useCallback, useEffect, useState} from 'react';
import {Button, Col, Collapse, Row} from "react-bootstrap";
import Wrapper from "../components/Wrapper.js";
import "react-datepicker/dist/react-datepicker.css";
import 'moment/locale/hy-am.js';
import MyButton from '../components/Button/Button.js'
import {word} from '../word.js'
import CheckboxFilter from "../components/CheckboxFilter.js";
import qs from "query-string";
import {useLocation, useNavigate} from "react-router-dom";
import AddTask from "../components/AddTask.js";
import SearchBar from "../components/SearchBar.js";
import TasksData from "../components/TaskData.js";
import RecommendationsItem from "../components/RecommendationsItem.js";
import {ClipLoader} from "react-spinners";
import {useDispatch, useSelector} from "react-redux";
import {taskDataRequest} from "../store/actions/task.js";
import _ from "lodash";
import CustomPagination from "../components/BlueButton/CustomPagination.js";
import DeleteItem from "../components/TaskSingleComponents/DeleteItem.js";
import AddMultipleTask from "../components/AddMultipleTask.js";

const date = new Date()
date.setMonth(date.getMonth() - 3)
const end_date = new Date()
end_date.setDate(end_date.getDate() + 1);

const profession = localStorage.getItem('profession')

function Tasks(props) {
    const location = useLocation()
    const login = useSelector((state) => state.manager.employee);
    const dispatch = useDispatch()
    const myTask = useSelector((state) => state.task.tasks)
    const loading = useSelector((state) => state.task.taskStatus)
    const navigate = useNavigate()

    const parsedQuery = qs.parse(location.search, {arrayFormat: 'comma'});

    const [multipleShow, setMultipleShow] = useState(false)
    const [show, setShow] = useState(false)
    const [deleteItem, setDelete] = useState(0)
    const [open, setOpen] = useState(false)

    const [buttons] = useState([
        {status: "new", title: word.new_created},
        {status: "approved", title: word.approved},
        {status: "process", title: word.in_the_process},
        {status: "end", title: word.completed},
    ]);

    const [filter, setFilter] = useState({
        accountant: parsedQuery.accountant ? parsedQuery.accountant : (profession === 'accountant' ? login?.id : ''),
        created_date: parsedQuery.created_date || date.toISOString().split('T')[0],
        created_date_end: parsedQuery.created_date_end || end_date.toISOString().split('T')[0],
        status: parsedQuery.status || 'approved',
        company: parsedQuery.company || null,
        manager: parsedQuery.manager || null,
        name: parsedQuery.name || null,
        offset: parsedQuery.offset || null,
        is_archive: false,
        order_by: 'desc%20created_date',
        page: parsedQuery.page ? Number(parsedQuery.page) : 1,
    })

    const [state, setState] = useState({
        file_exit: parsedQuery.file_exit === 'true' ? true : null,
        checked: parsedQuery.checked === 'true' ? true : parsedQuery.checked === 'false' ? false : null,
        is_active: parsedQuery.is_active === 'true' ? true : parsedQuery.is_active === 'false' ? false : null,
        is_after_deadline: parsedQuery.is_after_deadline === 'true' ? true : null,
        accountant_null: parsedQuery.accountant_null === 'true' ? true : parsedQuery.accountant_null === 'false' ? false : null,
    });

    const updateURL = (newFilter, newState) => {
        const queryObject = {...newFilter, ...newState};
        const queryString = qs.stringify(queryObject, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        });
        navigate(`?${queryString}`);
    };

    const handleButtonClick = (item) => {
        const newFilter = {...filter, status: item.status, page: 1};
        setFilter(newFilter);
        updateURL(newFilter, state);
    };

    const handlePageChange = (pageNumber) => {
        const offset = pageNumber === 0 ? null : (pageNumber - 1) * 10;
        const newFilter = {...filter, page: pageNumber, offset: offset};
        setFilter(newFilter);
        updateURL(newFilter, state);
    };

    const handleFilter = useCallback((name, value, type) => {
        if (type === 'filter') {
            const newFilter = {...filter, [name]: value, page: 1};
            setFilter(newFilter);
            updateURL(newFilter, state);
        } else {
            const newState = {...state, [name]: value};
            setState(newState);
            updateURL(filter, newState);
        }
    }, [filter, state]);

    const toggleState = (key, value) => {
        const newState = {...state, [key]: value};
        setState(newState);
        updateURL(filter, newState);
    };
    useEffect(() => {
        if (!location.search || location.search === '?') {
            const queryString = qs.stringify({...filter, ...state}, {
                arrayFormat: 'comma',
                skipEmptyString: true,
            });
            navigate(`?${queryString}`, {replace: true});
        }
    }, []);
    useEffect(() => {
        const queryString = qs.stringify({...filter, ...state}, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        });
        dispatch(taskDataRequest(queryString));
    }, [location.search]);

    useEffect(() => {
        if (profession === 'accountant' && login?.id) {
            setFilter(prev => {
                const newFilter = {...prev, accountant: login.id};
                updateURL(newFilter, state);
                return newFilter;
            });
        }
    }, [login]);

    return (
        <Wrapper>
            <div className='tasks'>
                <div className="plus-cont" onClick={() => setShow(true)}>
                    <span className='plus'>+</span>
                    <span className="tooltiptext">{word.addItem}</span>
                </div>
                <div className="plus-cont" onClick={() => setMultipleShow(true)}>
                    <span className='plus'>+</span>
                    <span className="tooltiptext">Ավելացնել առաջադրանքներ մի քանի կազմակերպությունների համար</span>
                </div>
                <Button onClick={() => setOpen(!open)}>
                    Ֆիլտրել առաջադրանքները
                </Button>
                <Collapse in={open}>
                    <div>
                        {profession !== "accountant" && (
                            <>
                                <CheckboxFilter
                                    title="Իմ առաջադրանքները"
                                    my_task={state.accountant_null === true}
                                    onChange={() => toggleState('accountant_null', state.accountant_null === true ? null : true)}
                                />
                                <CheckboxFilter
                                    title="Ինձ կցված առաջադրանքները"
                                    my_task={state.accountant_null === false}
                                    onChange={() => toggleState('accountant_null', state.accountant_null === false ? null : false)}
                                />
                            </>
                        )}
                        <CheckboxFilter title="Ֆայլերով" my_task={state.file_exit}
                                        onChange={() => toggleState('file_exit', state.file_exit ? null : true)}/>
                        <CheckboxFilter title="Ստուգված" my_task={state.checked === true}
                                        onChange={() => toggleState('checked', state.checked === true ? null : true)}/>
                        <CheckboxFilter title="Չստուգված" my_task={state.checked === false}
                                        onChange={() => toggleState('checked', state.checked === false ? null : false)}/>
                        <CheckboxFilter title="Ակտիվ" my_task={state.is_active === true}
                                        onChange={() => toggleState('is_active', state.is_active === true ? null : true)}/>
                        <CheckboxFilter title="Պասիվ" my_task={state.is_active === false}
                                        onChange={() => toggleState('is_active', state.is_active === false ? null : false)}/>
                        <CheckboxFilter title="Ժամկետանց" my_task={state.is_after_deadline === true}
                                        onChange={() => toggleState('is_after_deadline', state.is_after_deadline === true ? null : true)}/>
                    </div>
                </Collapse>

                <TasksData setFilter={setFilter} profession={profession}/>
                <SearchBar onChange={(value) => handleFilter('name', value, 'filter')} value={filter.name}/>

                <div className='tasks-buttons' style={{marginTop: 10}}>
                    {buttons.map((item, index) => {
                        if (item.status === "new" && profession === "accountant") {
                            return null;
                        }
                        return (
                            <MyButton
                                key={index}
                                buttonStyle={(filter.status !== item.status) ?
                                    "middle-button task-button" : "middle-button task-button task-button-active"}
                                title={item.title}
                                onChangeValue={() => handleButtonClick(item)}
                            />
                        );
                    })}
                </div>

                <div className='tasks-cont'>
                    {loading === 'request' ? (
                        <div className="loaderMargin"><ClipLoader type="Oval" color="#101C2A" size={30}/></div>
                    ) : (
                        <Row className="flex-row">
                            {myTask?.results?.length ? myTask.results.map((item, index) => (
                                <Col md={6} key={index}>
                                    <RecommendationsItem
                                        child_tasks={!_.isEmpty(item?.parent_task)}
                                        toLink={`/main_employee/tasks/${item.id}`}
                                        item={item}
                                        modalShow={() => setDelete(item.id)}
                                        getTaskData={async () => {
                                            const queryString = qs.stringify({...filter, ...state}, {
                                                arrayFormat: 'comma',
                                                skipEmptyString: true,
                                            });
                                            await dispatch(taskDataRequest(queryString));
                                        }}
                                    />
                                </Col>
                            )) : <div className="no_tasks text-center">{word.no_tasks}</div>}
                        </Row>
                    )}
                </div>

                {myTask?.count > 10 && (
                    <div className="d-flex justify-content-center">
                        <CustomPagination
                            currentPage={filter.page}
                            totalItems={myTask.count}
                            itemsPerPage={10}
                            totalPages={Math.ceil(myTask.count / 10)}
                            onPageChange={handlePageChange}
                        />
                    </div>
                )}
            </div>

            {show && <AddTask getData={() => dispatch(taskDataRequest(qs.stringify({...filter, ...state}, {arrayFormat: 'comma', skipEmptyString: true})))} show={show} onHide={() => setShow(false)}/>}
            {deleteItem ? <DeleteItem open={deleteItem} setOpen={setDelete}/> : null}
            {multipleShow && <AddMultipleTask show={multipleShow} onHide={() => setMultipleShow(false)}/>}
        </Wrapper>
    );
}

export default Tasks;
